defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Faq/FaqComponent',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Faq/FaqItem'
  ],
  function (m, FaqItem) {
    var FaqComponent = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.items = this.faqItems || [];
        this.openedItemIndex = m.prop(null);
      },
      view: function (controller) {
        return m('.play-together-faq__items-wrapper', controller.items.map((item, index) => {
          return m(FaqItem, { controller, item, index });
        }));
      }
    };

    // Public functions:
    return FaqComponent;
  });
